import { DEFAULT_CURRENCY_SYMBOL } from './constants';

/**
 * تنسيق المبلغ كعملة (استخدم useCurrency hook بدلاً من هذه الدالة)
 * @param amount المبلغ
 * @param currency رمز العملة (افتراضيًا: العملة الافتراضية من إعدادات النظام)
 * @returns المبلغ المنسق كعملة
 * @deprecated استخدم useCurrency hook بدلاً من هذه الدالة
 */
export const formatCurrency = (amount: number, currency: string = DEFAULT_CURRENCY_SYMBOL): string => {
  return `${amount.toLocaleString('ar-SA')} ${currency}`;
};

/**
 * تنسيق المبلغ كعملة مع العملة الافتراضية
 * @param amount المبلغ
 * @returns المبلغ المنسق كعملة
 * @deprecated استخدم useCurrency hook بدلاً من هذه الدالة
 */
export const formatCurrencyDefault = (amount: number | undefined | null): string => {
  if (amount === undefined || amount === null) {
    return `0.00 ${DEFAULT_CURRENCY_SYMBOL}`;
  }
  return `${amount.toFixed(2)} ${DEFAULT_CURRENCY_SYMBOL}`;
};

/**
 * تنسيق التاريخ
 * @param date التاريخ
 * @param options خيارات التنسيق
 * @returns التاريخ المنسق
 */
export const formatDate = (date: Date | string, options: Intl.DateTimeFormatOptions = {}): string => {
  const dateObj = typeof date === 'string' ? new Date(date) : date;

  const defaultOptions: Intl.DateTimeFormatOptions = {
    year: 'numeric',
    month: 'long',
    day: 'numeric',
    ...options
  };

  return dateObj.toLocaleDateString('ar-SA', defaultOptions);
};

/**
 * تنسيق الوقت
 * @param date التاريخ والوقت
 * @returns الوقت المنسق
 */
export const formatTime = (date: Date | string): string => {
  const dateObj = typeof date === 'string' ? new Date(date) : date;

  return dateObj.toLocaleTimeString('ar-SA', {
    hour: '2-digit',
    minute: '2-digit'
  });
};

/**
 * تنسيق التاريخ والوقت معًا
 * @param date التاريخ والوقت
 * @returns التاريخ والوقت المنسقين
 */
export const formatDateTime = (date: Date | string): string => {
  const dateObj = typeof date === 'string' ? new Date(date) : date;

  return `${formatDate(dateObj)} ${formatTime(dateObj)}`;
};

/**
 * تنسيق النسبة المئوية
 * @param value القيمة
 * @returns النسبة المئوية المنسقة
 */
export const formatPercentage = (value: number): string => {
  return `${value.toLocaleString('ar-SA', { maximumFractionDigits: 1 })}%`;
};

/**
 * تنسيق الرقم
 * @param value القيمة
 * @param fractionDigits عدد الأرقام العشرية
 * @returns الرقم المنسق
 */
export const formatNumber = (value: number, fractionDigits: number = 0): string => {
  return value.toLocaleString('ar-SA', {
    minimumFractionDigits: fractionDigits,
    maximumFractionDigits: fractionDigits
  });
};

/**
 * تنسيق رقم الهاتف
 * @param phone رقم الهاتف
 * @returns رقم الهاتف المنسق
 */
export const formatPhone = (phone: string): string => {
  if (!phone) return '';

  // إزالة أي أحرف غير رقمية
  const cleaned = phone.replace(/\D/g, '');

  // التحقق من طول الرقم
  if (cleaned.length !== 10) {
    return phone; // إرجاع الرقم كما هو إذا لم يكن بالتنسيق المتوقع
  }

  // تنسيق الرقم: 05X XXX XXXX
  return `${cleaned.slice(0, 3)} ${cleaned.slice(3, 6)} ${cleaned.slice(6)}`;
};
